// Post-type controls shared by the Free and Pro block editors.

import { parsePostTypeSelection } from './post-type-utils.mjs';

const { SelectControl, Spinner } = wp.components;
const { useEffect, useMemo, useState } = wp.element;
const { __ } = wp.i18n;

export function PostTypeSelect({
	setAttributes,
	block_post_types,
	options,
	multi = true,
}) {
	const selectedPostTypes = useMemo(
		() => parsePostTypeSelection(block_post_types),
		[block_post_types]
	);
	const selectedValues = selectedPostTypes.map(({ value }) => value);

	return (
		<SelectControl
			label={__('Select post types to display', 'simple-sitemap')}
			multiple={multi}
			value={multi ? selectedValues : selectedValues[0] || ''}
			options={options}
			onChange={(newValue) => {
				const values = Array.isArray(newValue) ? newValue : [newValue];
				const selected = values
					.map((value) =>
						options.find((option) => option.value === value)
					)
					.filter(Boolean);

				setAttributes({
					block_post_types: JSON.stringify(
						multi ? selected : selected[0]
					),
				});
			}}
		/>
	);
}

/**
 * Pro post-type selector. Data failures leave a clear, recoverable editor state.
 *
 * @param {Object} props Component properties.
 * @return {Element} Post-type selector or its current state.
 */
export function SelectCPT(props) {
	const [types, setTypes] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');

	useEffect(() => {
		let active = true;

		wp.apiFetch({
			path: '/wp/v2/types?context=edit',
			method: 'GET',
		}).then(
			(data) => {
				if (!active) {
					return;
				}

				setTypes(
					Object.values(data || {})
						.filter(({ slug, viewable }) =>
							Boolean(viewable && slug !== 'attachment')
						)
						.map(({ slug, name }) => ({ value: slug, label: name }))
				);
				setLoading(false);
			},
			() => {
				if (active) {
					setTypes([]);
					setError(
						__(
							'Unable to load post types. Please try again.',
							'simple-sitemap'
						)
					);
					setLoading(false);
				}
			}
		);

		return () => {
			active = false;
		};
	}, []);

	if (loading) {
		return <Spinner />;
	}

	if (error) {
		return <p className="simple-sitemap-control-error">{error}</p>;
	}

	return <PostTypeSelect {...props} options={types} />;
}
